import {
  CompanyLogo,
  CompanySettings,
} from '~/common/entities/CompanySettings/CompanySettingsTypes';
import { EditCompanySettingsResponse } from '~/common/entities/CompanySettings/CompanySettingsResponses';
import { CompanySettingsRequest } from '~/common/entities/CompanySettings/CompanySettingsRequests';
import { useAuthenticationService } from './AuthenticationService';
import { ApiErrorCallback, ApiSuccessCallback } from './callback';
import { authenticatedApi } from '../utils/authenticatedApi';
import { createContainer } from 'unstated-next';
import { useState } from 'react';

function useCompanySettings() {
  const [companySettings, setCompanySettings] = useState<CompanySettings>();

  const { authenticationState } = useAuthenticationService();

  const editCompanySettings = async (
    editCompanySettingsRequest: CompanySettingsRequest,
    onSuccess?: ApiSuccessCallback<EditCompanySettingsResponse>,
    onError?: ApiErrorCallback,
  ) => {
    const values = editCompanySettingsRequest;

    const { data, error: ApiError } = await authenticatedApi(
      authenticationState,
    ).put<EditCompanySettingsResponse, CompanySettingsRequest>(
      '/company/settings/',
      values,
    );
    if (ApiError && onError) onError();
    if (data && onSuccess) onSuccess(data);
  };

  const setCompanyLogo = async (
    companyLogo: CompanyLogo,
    onSuccess?: ApiSuccessCallback<CompanyLogo>,
    onError?: ApiErrorCallback,
  ) => {
    let newBase64 = 'data:image/jpeg;base64,';
    newBase64 += companyLogo.picture;
    companyLogo.picture = newBase64;
    // console.log(companyLogo.picture);

    const { data, error } = await authenticatedApi(authenticationState).post<
      undefined,
      CompanyLogo
    >('/logo/company/', companyLogo);

    if (error && onError) onError();
    // console.log(data);
    if (data) {
      if (onSuccess) onSuccess(companyLogo);
    }
  };

  const fetchCompanyLogo = async (
    onSuccess?: ApiSuccessCallback<CompanyLogo>,
    onError?: ApiErrorCallback,
  ) => {
    const { data, error } =
      await authenticatedApi(authenticationState).get<CompanyLogo>(
        '/logo/company/',
      );

    console.log(data);
    if (error && onError) onError();
    if (data) {
      if (onSuccess) onSuccess(data);
    }
  };

  const fillStoreWithServerData = async (
    onSuccess?: ApiSuccessCallback<CompanySettings>,
    onError?: ApiErrorCallback,
  ) => {
    const { data, error } =
      await authenticatedApi(authenticationState).get<CompanySettings>(
        '/company/settings/',
      );
    if (error) {
      return onError ? onError(error) : undefined;
    }

    if (data) {
      if (typeof data.look_back_duration === 'string')
        data.look_back_duration = parseInt(
          (data.look_back_duration as string).split(' ')[0],
          10,
        );
      if (typeof data.auto_end_timestamp_threshold === 'string')
        data.auto_end_timestamp_threshold = parseInt(
          (data.auto_end_timestamp_threshold as string).split(' ')[0],
          10,
        );
      if (typeof data.max_factor === 'string')
        data.max_factor = parseFloat(data.max_factor);
      if (typeof data.max_mean_factor === 'string')
        data.max_mean_factor = parseFloat(data.max_mean_factor);
      if (!data.order_kw_instead_of_date) data.order_kw_instead_of_date = false;

      setCompanySettings(data);
    }
    return onSuccess ? onSuccess(data) : undefined;
  };

  return {
    companySettings,
    fillStoreWithServerData,
    editCompanySettings,
    setCompanyLogo,
    fetchCompanyLogo,
  };
}

export const {
  Provider: CompanySettingsProvider,
  useContainer: useCompanySettingsService,
} = createContainer(useCompanySettings);
